<template>
  <div
    class="controlItemWrapper"
    :class="control.className"
    :data-control-name="control.name"
  >
    <div
      class="controlItem row"
      :id="control.name"
      v-if="labelPosition === 'left'"
    >
      <div class="col-md-4">
        <label
          :class="{
            bold: control.labelBold,
            italic: control.labelItalic,
            underline: control.labelUnderline
          }"
        >
          {{ control.label }}
        </label>
      </div>
      <div class="col-md-8 input-group">
        <input
          type="text"
          class="form-control"
          :readonly="control.readonly"
          :name="control.fieldName"
          :value="default_value"
          :maxlength="max_length"
        />
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{
            bold: control.labelBold,
            italic: control.labelItalic,
            underline: control.labelUnderline
          }"
        >
          {{ control.label }}
        </label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            :readonly="control.readonly"
            :name="control.fieldName"
            :value="default_value"
            :maxlength="max_length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'raTextControl',
  props: ['control', 'labelPosition'],
  computed: {
    max_length() {
      if (_.toInteger(this.control.maxLength) > 0) {
        return this.control.maxLength;
      }
      return null;
    },
    default_value() {
      if (!_.isEmpty(this.control.defaultValue)) {
        return this.control.defaultValue;
      }
      return '';
    }
  }
};
</script>

<style scoped></style>
